import {
    ERROR_MESSAGES,
} from 'constants/validation-error-messages';
import * as yup from 'yup';

export const schema = yup.object({
    workplace_name: yup.string().required(ERROR_MESSAGES.REQUIRED),
    workplace_address_postcode: yup.string().required(ERROR_MESSAGES.REQUIRED),
    workplace_address_city: yup.string().required(ERROR_MESSAGES.REQUIRED),
    workplace_address_street: yup.string().required(ERROR_MESSAGES.REQUIRED),
    workplace_address_number: yup.string().required(ERROR_MESSAGES.REQUIRED),
});